import styled from "styled-components"
import { TokenCounter } from 'components/pages/common'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
`

export const TokenCounterStyled = styled(TokenCounter)`
  
`